import { render } from "./AposIndicator.vue?vue&type=template&id=db0e4bbe&scoped=true"
import script from "./AposIndicator.vue?vue&type=script&lang=js"
export * from "./AposIndicator.vue?vue&type=script&lang=js"

import "./AposIndicator.vue?vue&type=style&index=0&id=db0e4bbe&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0e4bbe"],['__file',"ui/ui/apos/components/AposIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db0e4bbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db0e4bbe', __exports__)) {
    api.reload('db0e4bbe', __exports__)
  }
  
  module.hot.accept("./AposIndicator.vue?vue&type=template&id=db0e4bbe&scoped=true", () => {
    api.rerender('db0e4bbe', render)
  })

}


export default __exports__